import React, { Component } from 'react'
import { getFirstFocusableScopedElement } from 'utilities'
import { Attribute } from './Attribute'
import shortid from 'shortid'
import MASKS from '../Wizard2/masks'
import { Checkbox } from '@tecuity/granite-ui/Checkbox'
import { IconButton } from '@tecuity/granite-ui'
import PencilIcon from '@tecuity/sos-icons/react/pencil-solid'

export default class MaskEditor extends Component {
  constructor(props) {
    super(props)
    this.name = shortid.generate()
    this.state = {
      currentMask: props.field.mask[0] ? props.field.mask[0].fn : '',
      props: this.buildMaskObject(props),
      allowedMasks: props.field.allowedMasks,
      masks: (!Array.isArray(props.field.mask) ? [] : props.field.mask).map((mask) => {
        if (!mask.props) {
          mask.props = {}
        }
        const entries = Object.keys(mask.props)
        Object.entries(MASKS[mask.fn].props).forEach((maskProp) => {
          if (entries.includes(maskProp[0])) {
            MASKS[mask.fn].props[maskProp[0]].value = mask.props[maskProp[0]]
          }
        })
        return {
          ...mask,
          props: {
            ...MASKS[mask.fn].props,
          },
        }
      }),
    }
  }
  buildMaskObject = (props) => {
    let maskProps = {}
    if (props.field.mask[0]) {
      Object.keys(MASKS[props.field.mask[0].fn].props).forEach((propId) => {
        maskProps[propId] = {
          ...MASKS[props.field.mask[0].fn].props[propId],
          value: (props.field.mask[0].props || {})[propId],
        }
      })
    }
    return maskProps
  }
  clearState = () => {
    this.setState({
      props: this.buildMaskObject(this.props),
      masks: [],
    })
  }
  setMaskValue = (fn) => {
    if (MASKS[fn]) {
      const maskProps = this.state.masks.find((mask) => mask.fn === fn)
        ? this.state.masks.find((mask) => mask.fn === fn).props
        : MASKS[fn].props

      let newProps = {}
      Object.keys(maskProps).forEach((propId) => {
        if (propId !== 'isCheckbox') {
          newProps[propId] =
            typeof maskProps[propId] === 'object' ? maskProps[propId].value : maskProps[propId]
        }
      })

      this.setState((state) => ({
        currentMask: state.masks.find((mask) => mask.fn === fn) ? '' : fn,
        masks: state.masks.find((mask) => mask.fn === fn)
          ? state.masks.filter((mask) => mask.fn !== fn)
          : MASKS[fn].props.isCheckbox
          ? [...state.masks, { fn: fn, props: maskProps }]
          : [
              ...state.masks.filter((mask) => mask.props && mask.props.isCheckbox === true),
              { fn: fn, props: maskProps },
            ],
        props: state.masks.find((mask) => mask.fn === fn) ? {} : maskProps || {},
      }))
      const firstElement = getFirstFocusableScopedElement('.attribute-container')
      if (firstElement) {
        firstElement.focus()
      }
    }
  }
  setCurrentMask = (fn) => {
    this.setState((state) => ({
      currentMask: fn,
      props: state.masks.find((mask) => mask.fn === fn).props,
    }))
  }
  saveRules = () => {
    this.props.handleChange(
      'mask',
      this.state.masks.length > 0
        ? this.state.masks
            .filter((mask) => mask.fn)
            .map((mask) => {
              let newProps = {}
              Object.keys(mask.props).forEach((propId) => {
                if (propId !== 'isCheckbox') {
                  newProps[propId] = mask.props[propId].value
                }
              })
              return {
                fn: mask.fn,
                props: newProps,
              }
            })
        : []
    )
  }
  setPropValue = (name, value) => {
    const currentMask = this.state.masks.find((mask) => mask.fn === this.state.currentMask)
    this.setState((state) => ({
      masks: [...state.masks, ...(currentMask.props[name].value = value)],
      props: { ...state.props, [name]: { ...state.props[name], value } },
    }))
  }
  render() {
    const { disabled, leftAlign } = this.props
    const { masks, props, allowedMasks } = this.state
    return (
      <div className="validation-editor">
        <div className="row">
          <div className="col-6 rule-container">
            <div
              name={this.name}
              className={'radio-group ' + (disabled ? 'disabled' : '')}
              onChange={this.setMaskValue}
            >
              <div>
                <div role="tablist" aria-label="Input Mask Options" aria-orientation="vertical">
                  {allowedMasks.filter((mask) => !MASKS[mask].props.isCheckbox).length > 0 && (
                    <h2 style={{ padding: '10px 0 5px' }}>Masks</h2>
                  )}
                  {allowedMasks
                    .filter((mask) => !MASKS[mask].props.isCheckbox)
                    .map((maskId, i) => {
                      return (
                        <div
                          key={maskId}
                          aria-selected={!!masks.find((mask) => mask.fn === maskId)}
                          role="tab"
                        >
                          <OptionRow
                            leftAlign={leftAlign}
                            disabled={disabled}
                            {...MASKS[maskId]}
                            selected={!!masks.find((mask) => mask.fn === maskId)}
                            setMaskValue={this.setMaskValue}
                            isCheckbox={MASKS[maskId].props.isCheckbox}
                            isActive={maskId === this.state.currentMask}
                          />
                        </div>
                      )
                    })}
                  {allowedMasks.filter((mask) => MASKS[mask].props.isCheckbox === true).length >
                    0 && <h2 style={{ padding: '10px 0 5px' }}>Modifiers</h2>}
                  {allowedMasks
                    .filter((mask) => MASKS[mask].props.isCheckbox === true)
                    .map((maskId, i) => {
                      return (
                        <div
                          key={maskId}
                          aria-selected={!!masks.find((mask) => mask.fn === maskId)}
                          role="tab"
                        >
                          <OptionRow
                            leftAlign={leftAlign}
                            disabled={disabled}
                            {...MASKS[maskId]}
                            selected={!!masks.find((mask) => mask.fn === maskId)}
                            setMaskValue={this.setMaskValue}
                            isCheckbox={MASKS[maskId].props.isCheckbox}
                            isActive={maskId === this.state.currentMask}
                            setCurrentMask={this.setCurrentMask}
                          />
                        </div>
                      )
                    })}
                </div>
              </div>
            </div>
          </div>
          <div className="attribute-container col-6">
            <div className="no-outline" tabIndex="0" role="tabpanel">
              {this.state.masks.length > 0 && props ? (
                Object.keys(props).filter((prop) => prop !== 'isCheckbox').length === 0 ? (
                  <div className="options-message">This mask has no additional options.</div>
                ) : (
                  Object.keys(props)
                    .filter((prop) => prop !== 'isCheckbox')
                    .map((propId) => {
                      let prop = props[propId]
                      return (
                        <div key={propId}>
                          <Attribute
                            label={prop.label}
                            type={prop.type}
                            name={propId}
                            value={prop.value}
                            maxValue={prop.maxValue}
                            minValue={prop.minValue}
                            step={prop.step}
                            handleChange={this.setPropValue}
                          />
                        </div>
                      )
                    })
                )
              ) : null}
            </div>
          </div>
        </div>
      </div>
    )
  }
}

class OptionRow extends Component {
  constructor() {
    super()
    this.name = shortid.generate()
  }
  setMaskValue = () => {
    this.props.setMaskValue(this.props.fn)
  }
  handleKeyDown = (e) => {
    if (e.keyCode === 13 || e.keyCode === 32) {
      this.setMaskValue(this.props.fn)
    }
  }
  render() {
    const { leftAlign, name, selected, isCheckbox, isActive } = this.props
    return (
      <div
        tabIndex="0"
        onKeyDown={this.handleKeyDown}
        style={{ boxShadow: `${isActive ? '0px 0px 1px 2px rgb(102,187,214)' : 'none'}` }}
        className={
          'custom-focus ' +
          'option-wrapper rule ' +
          (leftAlign ? 'left-align ' : ' ') +
          (selected ? 'checked ' : '')
        }
        onClick={isCheckbox ? null : this.setMaskValue}
      >
        {isCheckbox ? (
          <React.Fragment>
            <Checkbox
              checked={selected}
              customCss={{
                flex: '1',
                label: {
                  fontSize: '0.9rem',
                  fontWeight: 'normal',
                  color: `${selected ? '#fff' : '#222'}`,
                },
              }}
              label={name}
              onChange={this.setMaskValue}
            />
            {selected && (
              <IconButton
                onClick={() => this.props.setCurrentMask(this.props.fn)}
                icon={<PencilIcon width="18" height="18" style={{ color: '#fff' }} />}
                label="Edit Modifier"
                customCss={'width: 18px; height: 18px; div {width: 18px; height: 18px}'}
              />
            )}
          </React.Fragment>
        ) : (
          <label className="field-label radio-label rule-name" htmlFor={this.name}>
            {name}
          </label>
        )}
      </div>
    )
  }
}
